<nz-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [nzDisabled]="disabled" [nzMode]="hxMode"
           nzPlaceHolder="Выберите категорию" [nzDropdownMatchSelectWidth]="false" nzAllowClear nzShowSearch>
  <nz-option *ngFor="let op of options" [nzLabel]="op.title | uiLabel" [nzValue]="op.id"></nz-option>
</nz-select>
